import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LoadingPanelService } from './loading-panel.service';

@Injectable()
export class LoadingPanelInterceptor implements HttpInterceptor {

  constructor(
    private loadingPanelSvc: LoadingPanelService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ts = Date.now().valueOf();
    const record = { [req.url]: ts };

    this.loadingPanelSvc.addToQueue(record);

    return new Observable(observer => {
      const sub = next.handle(req).subscribe(
        event => {
          if (event instanceof HttpResponse) {
            this.loadingPanelSvc.removeFromQueue(record);
            observer.next(event);
          }
        },
        err => {
          this.loadingPanelSvc.removeFromQueue(record);
          observer.error(err);
        },
        () => observer.complete());
      return () => {
        // canceled request;
        this.loadingPanelSvc.removeFromQueue(record);
        sub.unsubscribe();
      };
    });
  }

}
